import { render, staticRenderFns } from "./caracteristicas.vue?vue&type=template&id=2e86ef11&scoped=true&"
import script from "./caracteristicas.vue?vue&type=script&lang=js&"
export * from "./caracteristicas.vue?vue&type=script&lang=js&"
import style0 from "./caracteristicas.vue?vue&type=style&index=0&id=2e86ef11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e86ef11",
  null
  
)

export default component.exports